import api from "./axios";
import { createBoleta, downloadDocument } from "../utils/fetchReceipts";

export const createReceipts = async (deliveryDate) => {
  const body = {
    date: deliveryDate,
  };
  const result = await api.post("/receipts/create-bulk", body);
  return result;
};

export const downloadReceipts = async (deliveryDate) => {
  const body = {
    date: deliveryDate,
  };
  const response = await api.post(
    "/receipts/download-receipts-by-delivery-date",
    body,
    {
      responseType: "blob",
    }
  );
  return response;
};

export const downloadReceipts8cm = async (deliveryDate) => {
  const body = {
    date: deliveryDate,
  };
  const response = await api.post(
    "/receipts/download-receipts-8cm-by-delivery-date",
    body,
    {
      responseType: "blob",
    }
  );
  return response;
};

export const getReceiptRequestsByDate = async (deliveryDate) => {
  const result = await api.get(
    `/receipts/get-receipt-request-by-delivery-date?date=${deliveryDate}`
  );
  return result;
};

export const createReceiptForOrder = (orderId) => createBoleta(orderId);

export const downloadReceiptPdf = (documentId, dailyId) =>
  downloadDocument(documentId, dailyId);

export const downloadReceiptsFiltered = async (deliveryDate, orderIds, groupByDriver) => {
  const response = await api.post(
    "/receipts/download",
    { delivery_date: deliveryDate, order_ids: orderIds, group_by_driver: groupByDriver },
    { responseType: "blob" }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `Boletas_${deliveryDate}.zip`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
